module.exports = __webpack_public_path__ + "img/empty.2cc757e4.png";